import React from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import PartnerList from '../../../components/Partners/PartnersList/PartnerList';
import Loader from '../../../components/Common/Loader/Loader';
import { getAllUsersQuery } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';

import messages from '../../../locale/messages';

class Partners extends React.Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { partnerDetails, partnerDetails: { loading } } = this.props;

    return (
      <Loader type={"page"} show={loading}>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.partnerMenu)}</h1>
        {!loading && <PartnerList partnerDetails={partnerDetails} />}
      </Loader>
    );
  }
}

export default compose(
  injectIntl,
  withQuery(getAllUsersQuery, {
    name: 'partnerDetails',
    options: {
      variables: {
        currentPage: 1,
        searchList: '',
        userType: 2
      },
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),)(Partners);
